export default __webpack_public_path__ + "static/media/three-dots-vertical.92ac392d.svg";